import { render, staticRenderFns } from "./yilvkezhi.vue?vue&type=template&id=58f534ef&scoped=true&lang=pug"
import script from "./yilvkezhi.vue?vue&type=script&lang=ts"
export * from "./yilvkezhi.vue?vue&type=script&lang=ts"
import style0 from "./yilvkezhi.vue?vue&type=style&index=0&id=58f534ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f534ef",
  null
  
)

export default component.exports